import axios from 'axios'
import { supabase } from './supabase'

// In dev, requests go to relative /api/* which Vite proxies to the backend.
// In prod, VITE_API_URL = 'https://api.example.com' and the server routes /api/*.
const BASE = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api`
  : '/api'

export const api = axios.create({
  baseURL: BASE,
  timeout: 120_000,
})

// Attach Supabase JWT to every request
api.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Refresh token on 401 — one retry only, or a revoked session loops forever
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401 && err.config && !err.config._retried) {
      err.config._retried = true
      await supabase.auth.refreshSession()
      return api.request(err.config)
    }
    return Promise.reject(err)
  }
)
